import styled from 'styled-components/macro';

export const SidebarWrapper = styled.aside`
  /* border: greenyellow solid 1px; */
  margin: 0 2rem 1rem 0;
  min-width: 275px;
  border-radius: 10px;
  position: relative;
  /* overflow: hidden; */
  background-color: var(--color-white);
  box-shadow: var(--card-shadow);
`;
export const SidebarInner = styled.div`
  padding: 1rem;
`;
